import { useState, useCallback } from "react";

const STORAGE_PREFIX = "meesha:plan:lastViewedInfluencer:";

// Tracks which influencer's profile link was most recently opened for a given
// plan. Persisted to localStorage (not just component state) because opening
// a profile happens in a new tab — the plan tab is often revisited after a
// refresh or after being closed and reopened, not just a simple tab-switch.
export function useLastViewedInfluencer(planId) {
  const storageKey = planId ? `${STORAGE_PREFIX}${planId}` : null;
  const [lastViewedId, setLastViewedId] = useState(() => {
    if (!storageKey) return null;
    try {
      return localStorage.getItem(storageKey);
    } catch {
      return null;
    }
  });

  const markViewed = useCallback((influencerId) => {
    if (!storageKey || !influencerId) return;
    setLastViewedId(influencerId);
    try {
      localStorage.setItem(storageKey, influencerId);
    } catch {
      // Private-browsing/quota errors — highlight still works for this
      // session via the state above, it just won't survive a reload.
    }
  }, [storageKey]);

  return [lastViewedId, markViewed];
}
